"use client"

import { trackEvent } from "@src/utils/trackEvent"
import { useEffect } from "react"

const MILESTONES = [25, 50, 75, 100] as const

/**
 * Fires `landing_scroll_depth` once per milestone (25/50/75/100 %)
 * per page view. Renders nothing.
 */
export default function ScrollDepthTracker() {
  useEffect(() => {
    const seen = new Set<number>()

    const handleScroll = () => {
      const { scrollHeight } = document.documentElement
      if (scrollHeight <= 0) return

      const depth = ((window.scrollY + window.innerHeight) / scrollHeight) * 100

      for (const milestone of MILESTONES) {
        if (depth >= milestone && !seen.has(milestone)) {
          seen.add(milestone)
          trackEvent("landing_scroll_depth", { depth: milestone })
        }
      }

      if (seen.size === MILESTONES.length) {
        window.removeEventListener("scroll", handleScroll)
      }
    }

    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return null
}
